// extracted by mini-css-extract-plugin
export default {"root":"sponsor-search_root__BBvzb","sortDirection":"sponsor-search_sortDirection__PDrwd","iconUp":"sponsor-search_iconUp__gsJKj","iconDown":"sponsor-search_iconDown__7r51o"};